import { render, staticRenderFns } from "./formAction.vue?vue&type=template&id=052fb094&scoped=true&"
import script from "./formAction.vue?vue&type=script&lang=js&"
export * from "./formAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052fb094",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
installComponents(component, {VBottomNavigation})
